<div class="period-filter-container">
  <div class="title">
    <span>{{ title }}</span>
    <span *ngIf="subTitle">{{ subTitle }}</span>
  </div>

  <div class="controls" [formGroup]="form">
    <ng-container *ngIf="!calendarIsOpen && showBadgeDate">
      <ng-container  *ngFor="let days of dayOptions">
        <button
          class="btn-period"
          [ngClass]="{ active: selectedDays === days }"
          (click)="selectDays(days)"
          type="button">
          {{ days }} dias
        </button>
      </ng-container>

    </ng-container>


    <bfd-custom-datepicker
      [startDate]="form.value.start"
      [endDate]="form.value.end"
      [emitQuickRangeOnInit]="emitOnInit"
      [quickDays]="selectedDays > 0 ? selectedDays : null"
      [allowFutureDates]="scheduling"
      (calendarOpenedChange)="calendarIsOpen = $event"
      (rangeSelected)="onRangeChange($event)">
    </bfd-custom-datepicker>
  </div>


</div>